import { useEffect, useState } from 'react';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useTraits } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { SITE_USER } from '@atlassian/jira-traits/src/constants.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { hasTrait } from '@atlassian/jira-traits/src/utils.tsx';
import { useIsJiraNewUserTraitSelector } from './useIsJiraNewUserTraitSelector.tsx';

export const useYbrIsNewUser = (skip = false) => {
	const cloudId = useCloudId();
	const accountId = useAccountId();
	const [traits, { fetchTraits }] = useTraits();
	const [isYbrNewUser, setIsYbrNewUser] = useState(true);
	const [isJiraNewUser] = useIsJiraNewUserTraitSelector();

	useEffect(() => {
		if (skip || !accountId || !cloudId) {
			setIsYbrNewUser(false);
			return;
		}

		fetchTraits([SITE_USER], { cloudId, accountId });
	}, [skip, accountId, cloudId, fetchTraits]);

	useEffect(() => {
		// Wait until SITE_USER traits are loaded and jira_first_active trait is loaded before checking if user is actually a new user
		if (
			!traits[SITE_USER]?.loaded ||
			!traits[SITE_USER]?.attributes?.length ||
			!hasTrait(traits, 'jira_first_active')
		) {
			return;
		}

		// Only expose event if user is a new user
		if (!isJiraNewUser || !expVal('jira_ybr_first_batch', 'isYBREnabled', false)) {
			// If user is not a new user or the experiment is not enabled, user is not a YBR new user
			// which mean the message will be show as normal
			setIsYbrNewUser(false);
		}
	}, [isJiraNewUser, traits]);

	return [isYbrNewUser];
};
